import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-[320px] md:min-h-[340px] flex items-end justify-center overflow-hidden">
      {/* Background image + subtle diagonal scanline texture to match reference */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.34), rgba(255,255,255,0.34)), url('/images/topstockpickhero.webp')",
          filter: 'grayscale(100%)',
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'repeating-linear-gradient(115deg, rgba(255,255,255,0.20) 0px, rgba(255,255,255,0.20) 2px, rgba(255,255,255,0) 2px, rgba(255,255,255,0) 10px)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1200px] mx-auto lg:px-6 pb-0">
        <div className="relative translate-y-6 md:translate-y-8 flex flex-col items-center lg:block">
          {/* Rob's avatar - above card on mobile/md with margin-bottom, top-right on lg+ */}
          <div className="-mb-6 md:-mb-10 lg:mb-0 lg:absolute lg:left-auto lg:right-[13%] lg:-top-12 lg:translate-x-0 flex justify-center lg:block z-50">
            <div
              className="rounded-full overflow-hidden ring-[9px] ring-[#0B6054] bg-[#0B6054] w-[clamp(100px,22vw,140px)] h-[clamp(100px,22vw,140px)] lg:w-[clamp(80px,12vw,112px)] lg:h-[clamp(80px,12vw,112px)]"
              style={{ boxShadow: '0 8px 20px rgba(0,0,0,0.3)' }}
            >
              <img
                src="/images/RobertBruggeman.webp"
                alt="Rob Bruggeman"
                className="w-full h-full object-cover object-[center_18%]"
              />
            </div>
          </div>

          {/* Dark navy content box - full width on mobile/md, constrained on lg+ */}
          <div 
            className="bg-[#162948] lg:rounded-[16px] rounded-none w-full max-w-full lg:max-w-[min(83%,998px)] mx-auto text-center shadow-[0_10px_30px_rgba(0,0,0,0.28)] flex flex-col justify-center"
            style={{
              padding: 'clamp(1.5rem, 4%, 2.5rem) clamp(1.5rem, 4%, 3rem)',
              minHeight: 'clamp(180px, 28vh, 280px)',
            }}
          >
            <span className="text-[#D4A129] font-[400] text-[25px] md:text-[33px] ">
              Real Results:
            </span>
            <p className="mt-1 lg:mb-5 mb-2 text-[#FFFFFF] text-[20px] lg:text-[31px] font-[600] leading-[1.2] tracking-[0.01em]">
              Subscribers Who Acted on Rob&apos;s November 17, 2025 Pick Have More Than Doubled Their Money
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
